import { handle403 } from '../errorHandlers/handle403';
import { handle404 } from '../errorHandlers/handle404';
import { handleFallback } from '../errorHandlers/handleFallback';
import { formatDate } from '../functions/formatDate';
import { videoId, dev, staging } from '../functions/params';
import { updateHref } from '../functions/updateHref';
import { updateText } from '../functions/updateText';

let stashedPassword = '';

function reduce({ result }) {
  return {
    url: result.videoUrl,
    title: result.title,
    expireDate: result.expireDate,
  };
}

// Little (un)helper fn.
const doNothing = () => {};

function makeDownloadableFlow({ password }) {
  return [
    {
      id: 'authenticatePassword',
      get: {
        url: `${
          dev
            ? 'https://coach-logic-core-beta.azurewebsites.net'
            : staging
            ? 'https://coach-logic-core-staging.azurewebsites.net'
            : 'https://coach-logic-core.azurewebsites.net'
        }/api/share/public/${videoId}?passcode=${encodeURIComponent(password)}&format=MP4`,
      },
      reduce,
      saveDataAs: 'DOWNLOAD',
      onError: [handleFallback, handle403, handle404],
    },
    // { id: 'showDownloadBtn', call: () => displayElem('#download', 'inline-block') },
    { id: 'updateDownloadHref', useData: (store) => updateHref('#download', store.get('DOWNLOAD').url) }
  ]
}

export function authenticatePasswordFlow({ password, player }) {
  return [
    { id: 'hideForm', hide: '#passwordForm' },
    { id: 'displayLoadingOverlay', show: '#loadingOverlay' },
    {
      id: 'authenticatePassword',
      get: {
        url: `${
          dev
            ? 'https://coach-logic-core-beta.azurewebsites.net'
            : staging
            ? 'https://coach-logic-core-staging.azurewebsites.net'
            : 'https://coach-logic-core.azurewebsites.net'
        }/api/share/public/${videoId}?passcode=${encodeURIComponent(password)}&format=HLS`,
      },
      reduce,
      saveDataAs: 'VIDEO',
      onError: [handleFallback, handle403, handle404],
    },
    { id: 'stashPassword', call: () => { stashedPassword = password; }},
    { id: 'loadVideo', useData: (store) => player.src(store.get('VIDEO').url) },
    { id: 'updateTitle', useData: (store) => updateText('#video-title', store.get('VIDEO').title) },
    {
      id: 'updateExpires',
      useData: (store) => updateText('#video-expires', formatDate(store.get('VIDEO').expireDate)),
    },
    { id: 'showVideoData', show: '#video-data' },
    { id: 'showVideoElement', show: '#video-element' },
    { id: 'hideLoadingOverlay', hide: '#loadingOverlay' },
    { id: 'showCallToAction', show: '#call-to-action1' },
    { id: 'showCallToAction', show: '#call-to-action2' },
    // { id: 'makeDownloadable', useData: (store) => store.get('VIDEO').canDownload ? flowController.pushFlow({ flow: makeDownloadableFlow, args: { password } }) : doNothing },
    { id: 'play', call: () => player.play() },
  ];
}

export function saveToLibraryFlow({ env = 'beta' }) {
  console.log({ env });

  return [
    { id: 'storePassword', call: () => {
      document.cookie = `${env}-video-lib=${JSON.stringify({ key: videoId, value: stashedPassword })};path=/;domain=.coach-logic.com;max-age=6000`
    }},
    { id: 'redirectToVideoLibrary', call: () => {
      window.open(`${env === 'beta' ? 'https://beta.coach-logic.com' : 'https://app.coach-logic.com'}/s/videos`);
    }},
  ];
}
